import React from "react";
import { ChevronLeft } from "lucide-react";
import AccessibilityMenu from "./AccessibilityMenu";
import HelpButton from "./HelpButton";
import DemoControls from "./DemoControls";

export const AppShell = ({
    children,
    title,
    showBack = false,
    onBack,
    backLabel = "Back to Home",
    eyebrow,
    helpText,
    onSimulateInactivity,
}) => {
    return (
        <div className="min-h-screen w-full">
            <div className="mx-auto max-w-[480px] px-5 pt-5 pb-32 grain-bg">
                <header className="mb-5 flex items-center justify-between gap-3">
                    {showBack ? (
                        <button
                            type="button"
                            onClick={onBack}
                            aria-label={backLabel}
                            data-testid="back-to-home-btn"
                            className="inline-flex items-center gap-1.5 min-h-[44px] px-3 -ml-1.5 rounded-xl text-[#0A3D7A] font-semibold hover:bg-[#0A3D7A]/5 transition-colors"
                        >
                            <ChevronLeft className="w-5 h-5" aria-hidden="true" />
                            <span>{backLabel}</span>
                        </button>
                    ) : (
                        <div className="flex items-center gap-2">
                            <div
                                aria-hidden="true"
                                className="w-9 h-9 rounded-xl bg-[#0A3D7A] text-white flex items-center justify-center font-display font-bold"
                            >
                                C
                            </div>
                            <span className="font-display text-xl font-bold text-[#1A1A2E]">
                                MyClearPath
                            </span>
                        </div>
                    )}

                    <div className="flex items-center gap-2">
                        <DemoControls onSimulateInactivity={onSimulateInactivity} />
                        <HelpButton helpText={helpText} />
                        <AccessibilityMenu />
                    </div>
                </header>

                {(eyebrow || title) && (
                    <div className="mb-6">
                        {eyebrow && (
                            <p className="text-xs tracking-[0.22em] uppercase font-semibold text-[#B8860B] mb-1.5">
                                {eyebrow}
                            </p>
                        )}
                        {title && (
                            <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#1A1A2E] tracking-tight">
                                {title}
                            </h1>
                        )}
                    </div>
                )}

                {children}

                <footer className="mt-10 text-center">
                    <p className="text-xs text-[#5A5A6E]">
                        MyClearPath is a prototype.{" "}
                        <button
                            type="button"
                            onClick={() =>
                                window.alert(
                                    "MyClearPath is a non-functional design prototype. No real data is collected, stored, or transmitted. All readings, contacts, and transactions shown are simulated for demonstration only.",
                                )
                            }
                            data-testid="about-prototype-link"
                            className="underline underline-offset-2 text-[#0A3D7A] font-medium hover:text-[#082F5E]"
                        >
                            About this prototype
                        </button>
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default AppShell;
